import Link from 'next/link'
import { FC, useEffect } from 'react'

import Card from 'components/base/Card'
import classNames from 'classnames'
import trackIntent from 'common/trackIntent'

interface Props {
  className?: string
}

const WhatsAppBusinessCard: FC<Props> = ({ className }) => {
  useEffect(() => {
    void trackIntent('WHATSAPP_BUSINESS_CARD_VIEW')
  }, [])

  const handleClick = () => {
    void trackIntent('WHATSAPP_DASHBOARD_CLICK')
  }

  return (
    <Link
      href='/whatsapp-business'
      className={classNames(className, 'text-body')}
      onClick={handleClick}
    >
      <Card padding={'none'}>
        <div style={{ height: '100%', minHeight: 300 }} className='flex-row'>
          <div className='col-6 d-flex flex-column    ps-5 pt-6'>
            <div className='flex-1'>
              <h3 className='fw-bold mb-1'>
                Personalised WhatsApp Business Phone Number
              </h3>
              <div
                style={{ marginRight: '-5%' }}
                className='mb-4 fw-semibold fs-lg'
              >
                Connect with your customers directly, immediately and more
                effectively with our WhatsApp for Business number service for
                just £3.99/month
              </div>
            </div>
            <div className='mb-4'>
              <div className='btn btn-primary'>Get Started</div>
            </div>
          </div>
          <div className='col-6 position-relative  d-flex justify-content-center align-items-center'>
            <img
              src='/images/whatsapp/hero.png'
              alt='WhatsApp Business mascot'
              className='position-absolute bottom-0 end-0 hero-image'
              style={{
                maxHeight: '100%',
                maxWidth: '100%',
              }}
            />
          </div>
        </div>
      </Card>
    </Link>
  )
}

export default WhatsAppBusinessCard
